import { render, staticRenderFns } from "./viewLGEST.vue?vue&type=template&id=47813948&scoped=true"
import script from "./viewLGEST.vue?vue&type=script&lang=js"
export * from "./viewLGEST.vue?vue&type=script&lang=js"
import style0 from "./viewLGEST.vue?vue&type=style&index=0&id=47813948&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47813948",
  null
  
)

export default component.exports